import { PublicClientApplication, LogLevel, EventType } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: '6b22ead4-0a9e-4d81-a276-ed5dc254fcba',
        knownAuthorities: ['marketmonitor.b2clogin.com'],
        authority: 'https://login.microsoftonline.com/598d826e-f9ac-4db3-96f8-9e2a45ac87c7',
        redirectUri: process.env.REACT_APP_REDIRECTURI, 
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (true || containsPii || process.env.NODE_ENV !== "development") {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.info(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
              case LogLevel.Warning:
                console.warn(message);
                return;
              default:
                return;
            }
          },
        },
      }
}

export const protectedResources = {
scraperAPI: {
   endpoint: process.env.REACT_APP_ENDPOINT,
   scopes: ["https://marketmonitor.onmicrosoft.com/tasks-api/tasks.readwrite"],
 },
}

export const loginRequest = {
    scopes: [
      ...protectedResources.scraperAPI.scopes
    ],
  };

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: any) => {
  if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
  ) {
      msalInstance.setActiveAccount(event.payload.account);
  }
})